define('connections/product-block-connection',[
    'utils/ajax-util',

    'settings'
], function(ajax, settings) {

    return (function() {
        function ProductBlockConnection() {}

        ProductBlockConnection.prototype.getProductBlock = function(blockId) {
            return ajax.get(settings.productApiUrl + '/productlistblock/' + blockId);
        };

        return new ProductBlockConnection();
    })();
});
